import * as React from "react";
import {
  PieChart,
  Pie,
  ResponsiveContainer,
  Cell,
  Legend,
  Tooltip,
} from "recharts";
import { ISexStatistics } from "../types";
export interface ISexChartS {}
export interface ISexChart {
  data: ISexStatistics[];
}
export const CustomTooltip = (props) => {
  const { active, payload } = props;
  if (active && payload) {
    return (
      <div className="custom-tooltip">
        <p>{payload[0].name}</p>
        <p>
          {payload[0].name !== "No data found" && `count: ${payload[0].value}`}
        </p>
      </div>
    );
  }
  return null;
};
export class SexChart extends React.Component<ISexChart, ISexChartS> {
  constructor(props: ISexChart) {
    super(props);
    this.state = {};
  }
  public render() {
    const COLORS = ["#0092a0", "#D16200", "#DCAD00"];
    if (!this.props.data.length) {
      return <p>No Data to Show</p>;
    }
    return (
      <ResponsiveContainer width={"100%"} height={310}>
        <PieChart>
          <Pie
            cx="50%"
            cy="50%"
            innerRadius={90}
            outerRadius={120}
            fill="#8884d8"
            paddingAngle={5}
            dataKey={"count"}
            data={this.props.data}
          >
            {this.props.data.map((entry, index) => (
              <Cell
                key={index}
                fill={
                  this.props.data.length > 0
                    ? COLORS[index % COLORS.length]
                    : "#F3F3F3"
                }
              />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend align="center" verticalAlign="bottom" layout="horizontal" />
        </PieChart>
      </ResponsiveContainer>
    );
  }
}
export default SexChart;
